import React from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../contexts/DataContext';

const Footer = () => {
  const { data } = useData();
  const siteConfig = data.siteConfig;

  const footerLinks = {
    'Resumeslip': [
      { path: '/', label: 'Home' },
    ],
    'Contact Us': [
      { path: '/about', label: 'About us' },
      { path: '/contact', label: 'Contact us' }
    ],
    'Legal': [
      { path: '/privacy', label: 'Privacy Policy' },
    ]
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {Object.entries(footerLinks).map(([column, links]) => (
          <div className="footer-column" key={column}>
            <h3>{column}</h3>
            <ul>
              {links.map((link, index) => (
                <li key={`${column}-${index}-${link.label}`}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      
      <div className="footer-bottom">
        <p>{siteConfig?.footer_text || 'All Copyright by Resumeslip'}</p>
        
        {/* Social Links */}
        {siteConfig && (
          <div className="social-links">
            {siteConfig.social_facebook && (
              <a href={siteConfig.social_facebook} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook"></i>
              </a>
            )}
            {siteConfig.social_twitter && (
              <a href={siteConfig.social_twitter} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-twitter"></i>
              </a>
            )}
            {siteConfig.social_linkedin && (
              <a href={siteConfig.social_linkedin} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin"></i>
              </a>
            )}
            {siteConfig.social_instagram && (
              <a href={siteConfig.social_instagram} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
            )}
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;